import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	tooltip: {
		id: 'insights-board-button.tooltip',
		defaultMessage: 'Sprint insights',
		description: 'Tooltip describing the content that the button toggles',
	},
	tooltipTerminologyRefresh: {
		id: 'insights-board-button.tooltip-terminology-refresh',
		defaultMessage: 'Sprint health',
		description: 'Tooltip describing the content that the button toggles',
	},
});
